import {
  AnalyticsEventProperties,
  AnalyticsEventValue,
  isExtendedAnalyticsEvent,
} from 'core/analytics/entities';
import { AmplitudeService, FunnelStepService } from '../../interfaces';
import { AmplitudeServiceDecorator } from './AmplitudeServiceDecorator';

const screenEventNames = ['funnel_screen_open', 'funnel_screen_click'];

export class AmplitudeServiceWithFunnelStep extends AmplitudeServiceDecorator {
  constructor(
    amplitudeService: AmplitudeService,
    private readonly funnelStepService: FunnelStepService,
  ) {
    super(amplitudeService);
  }

  trackEvent(event: AnalyticsEventValue, properties: AnalyticsEventProperties = {}) {
    const eventName = isExtendedAnalyticsEvent(event) ? event.name : event;

    if (!screenEventNames.includes(eventName)) {
      return super.trackEvent(event, properties);
    }

    const stepNumber = this.funnelStepService.getStepNumber();
    const resetReason = this.funnelStepService.consumeResetReason();
    const stepProperties = stepNumber ? { funnel_step_number: stepNumber } : {};
    const resetProperties = resetReason ? { step_reset_reason: resetReason } : {};

    return super.trackEvent(event, {
      ...properties,
      ...stepProperties,
      ...resetProperties,
    });
  }
}
